// extracted by mini-css-extract-plugin
module.exports = {"orchid-pro-practice-group-icon":"styles_orchid-pro-practice-group-icon__3vZoF"};